module.exports = __webpack_public_path__ + "static/media/gear.55edc9ed.svg";